module.exports = __webpack_public_path__ + "img/apparcar.e12b61fc.png";